import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  START_GWS_SYNC,
  START_GWS_SYNC_ERROR,
  START_GWS_SYNC_SUCCESS,
  PROGRESS_GWS_SYNC,
  PROGRESS_GWS_SYNC_ERROR,
  PROGRESS_GWS_SYNC_SUCCESS
} from "./actions";

const INIT_STATE = {
  startGwsSync: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
  gwsSyncProcess: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
};


const gwsSyncReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case START_GWS_SYNC:
      return {
        ...state,
        startGwsSync: {
          ...state.startGwsSync,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };
    case START_GWS_SYNC_SUCCESS:
      return {
        ...state,
        startGwsSync: {
          ...state.startGwsSync,
          data: null,
          loading: false,
          error: false,
        },
      };

    case START_GWS_SYNC_ERROR:
      return {
        ...state,
        startGwsSync: {
          ...state.startGwsSync,
          loading: false,
          error: true,
          message: action.payload.toString(),
        },
      };

    case PROGRESS_GWS_SYNC:
      return {
        ...state,
        gwsSyncProcess: {
          data: !action.payload.loading ? state.gwsSyncProcess.data : null,
          loading: action.payload.loading,
          error: false,
          message: null,
        },
      };

    case PROGRESS_GWS_SYNC_SUCCESS: {
      return {
        ...state,
        gwsSyncProcess: {
          ...state.gwsSyncProcess,
          data: action.payload,
          loading: false,
          error: false,
          message: null,
        },
      };
    }
    case PROGRESS_GWS_SYNC_ERROR:
      return {
        ...state,
        gwsSyncProcess: {
          ...state.gwsSyncProcess,
          data: null,
          loading: false,
          error: true,
          message: action.payload,
        },
      };
    
    default:
      return state;
  }
};

export default gwsSyncReducer;
